export default {
  pageTitle: '座位场地布置',
  pageDesc: '维护全局可复用的座位场地，活动或会议需要时再绑定并编排。',
  addButton: '新建座位',
  notice: '用于活动现场的座位：可添加沙发席位 / 圆桌席位 / 影院席位 / 会议席位，拖拽排布，支持顺序与 C 位两种座号，完成后可导出 PNG 图片。',
  filters: '座位场地筛选',
  searchPlaceholder: '搜索场地名称或用途描述',
  allTypes: '全部座位类型',
  noMatch: '没有符合条件的座位场地',
  empty: '暂无座位场地',
  clearFilters: '清空筛选',
  unitCount: '座位单元',
  seatCount: '总座位数',
  editLayout: '编辑布置',
  countSummary: '共 {units} 个单元 · {seats} 个座位',
  noDescription: '暂无用途描述',
  createdAt: '创建于',
  deleteProtected: '该场地已关联活动或会议，不能删除',
  deleteProtectedUsage: '该场地存在使用记录，不能删除',
  deleteProtectedHistory: '该场地存在历史安排记录，不能删除',
  createTitle: '新建座位',
  editTitle: '编辑基础信息',
  name: '布置名称',
  namePlaceholder: '如：开幕式主会场座位',
  description: '用途描述',
  descriptionPlaceholder: '简单描述此布置的用途场景（选填）',
  seatTypes: '座位类型',
  typeHint: '选择本布置需要用到的座位类型，进入编辑后可继续添加',
  usedTypesHint: '以上为画布中已使用的座位类型（只读）。如需新增类型，请在画布左侧「添加座位单元」中操作。',
  nameRequired: '请输入布置名称',
  nameMax: '布置名称最多 100 个字符',
  descriptionMax: '用途描述最多 300 个字符',
  typesRequired: '请至少选择一种座位类型',
  createAndEdit: '创建并进入编辑',
  saveChanges: '保存修改',
  createSuccess: '座位场地已创建',
  updateSuccess: '基础信息已更新',
  deleteTitle: '删除座位场地',
  deleteConfirm: '确定删除“{name}”吗？删除后无法恢复。',
  deleteHint: '已关联活动或会议的场地不能删除；仅有历史使用记录的场地可以删除，使用记录会保留原场地名称。',
  deleteSuccess: '座位场地已删除',
  deleteFailed: '删除失败，请稍后重试',
  editor: {
    paletteTitle: '添加座位单元',
    clickToAdd: '点击添加到画布',
    typeShort: {
      sofa: '沙发',
      round: '圆桌',
      cinema: '影院',
      meeting: '会议',
      control: '控台'
    },
    capacityTitle: '可容纳人数',
    capacityUnit: '人',
    capacityHint: '实时汇总画布内全部座位',
    capacityEmpty: '尚未添加座位，点击上方类型开始布置',
    safetyExit: '安全出口',
    safetyExitShort: '安全出口',
    safetyExitHint: '拖拽到画布或点击添加',
    deleteSafetyExit: '删除安全出口',
    numberRuleTitle: '座号规则',
    numberRuleTitleHint: '（每个单元可单独设置）',
    numberRuleSequence: '顺序排号：第 1 排第 1 列起顺序编号',
    numberRuleCenter: 'C 位排号：中心为 1，向两侧交替（如 10·8·6·4·2·1·3·5·7·9），默认使用',
    backToList: '返回列表',
    backToArrangement: '返回座位编排',
    editInfo: '编辑基础信息',
    a4Hint: 'A4 版面（导出范围）· 编辑时大单元可拖出页外 · 每单元可单独设置座号与颜色',
    unsaved: '有未保存改动',
    lastSaved: '最后保存时间',
    lastSavedAtValue: '最后保存时间：{time}',
    notSaved: '尚未保存',
    landscape: '横向',
    portrait: '纵向',
    save: '保存布置',
    skipNumbers: '跳过号码',
    downloadPng: '下载 PNG',
    arrangeSeats: '座位安排',
    resetCanvas: '适应画布',
    canvasAria: '座位场地 SVG 编辑画布',
    stage: '舞台',
    anchorCount: '支点 {count} 组',
    scaleLabel: '比例 1m={value}px',
    zoomHint: '（支持触摸板双指捏合缩放）',
    venueSize: '场地尺寸：左长 {left}m · 右长 {right}m · 宽 {width}m',
    paperLandscape: 'A4 · 横向（210 × 297mm）',
    paperPortrait: 'A4 · 纵向（210 × 297mm）',
    venueInfo: '{shape} 上{top}m / 下{bottom}m · 左{left} / 右{right}m{pivotText}（比例 1m={scale}px）',
    pivotSuffix: ' · {count}支点',
    stageTag: 'STAGE',
    irregularVenue: '不规则场地',
    rectVenue: '矩形场地',
    topWidth: '上宽',
    bottomWidth: '下宽',
    leftLength: '左长',
    rightLength: '右长',
    venueTitle: '场地规划',
    venueDesc: '上下宽度与左右长度定义整体场地；拖动橙色支点只调整左右腰线，不会缩放舞台和座位。',
    anchorTitle: '场地支点',
    addPair: '增加支点',
    addPivot: '+ 增加支点',
    pairNo: '第 {no} 组支点',
    leftX: '左 X',
    leftY: '左 Y',
    rightX: '右 X',
    rightY: '右 Y',
    removePair: '删除该组支点',
    selectAnchorHint: '点击画布中的橙色支点进行编辑',
    topWidthField: '上宽度（m，h=0）',
    bottomWidthField: '下宽度（m，h=高度）',
    leftLengthField: '左长度（m）· 锚定',
    rightLengthField: '右长度（m）· 锚定',
    anchorTop: '顶',
    anchorCenter: '中',
    anchorBottom: '底',
    pivotTitle: '支点 {no}（左 / 右 可独立）',
    pivotLeftWidth: '左宽度（m）',
    pivotRightWidth: '右宽度（m）',
    pivotLeftHeight: '左高位置（m·距顶）',
    pivotRightHeight: '右高位置（m·距顶）',
    deletePivot: '× 删除',
    pivotEmptyHint: '点击「增加支点」在左右腰线上添加控制点。',
    venuePlanNote: 'A4 四周固定留白：上 120px、下 60px、左 / 右 60px（红色框）。上 / 下边缘为单一总宽度（左右对称）；每个支点的「左宽度 / 右宽度」与「左高位置 / 右高位置」均可独立调整：左值点连成左腰、右值点连成右腰，可表达斜腰 / 单侧凸出等复杂场地。支点左 + 右宽度之和不超过上 / 下宽包络；左 / 右高位置须在 0~对应侧长度之间。整体「左长度 / 右长度」可独立设置，底边可呈斜线。系统按最大边缩放居中到红色框内。',
    seatUnitEditHint: '点击画布中的座位单元',
    seatUnitEditHintSub: '可编辑名称与座位数',
    seatTotal: '{count} 个座位',
    backToVenue: '返回场地规划',
    unitTab: '座位单元',
    cardTab: '席位卡片',
    unitName: '单元名称',
    seatCount: '座位数量',
    chairWidth: '椅子宽（厘米）',
    chairHeight: '椅子长（厘米）',
    gap: '椅子间距（厘米）',
    diameter: '圆桌直径（米）',
    layoutMode: '座位排布方式',
    auto: '自动排布',
    manual: '手动设置',
    autoRoundHint: '自动排布：可容纳 {count} 把椅子',
    rows: '排数（行）',
    columns: '每排列数',
    tableWidth: '会议桌长（米）',
    tableHeight: '会议桌宽（米）',
    meetingTable: '会议桌',
    autoMeetingHint: '自动排布：长边 {long} 座 / 短边 {short} 座',
    sideTop: '上边座位数',
    sideRight: '右边座位数',
    sideBottom: '下边座位数',
    sideLeft: '左边座位数',
    color: '单元颜色',
    defaultColor: '默认（按类型）',
    defaultColorShort: '默',
    assignedSeatColor: '已分配座位背景色',
    assignedColorRandom: '随机',
    assignedColorUniform: '统一',
    assignedColorHint: '默认统一：已分配座位使用单元颜色；随机：每个已分配座位使用不同颜色。',
    numberMode: '座号方式',
    numberSequence: '顺序排号',
    numberCPosition: 'C 位排号',
    startDirection: '起始方向（1 号位置）',
    cDirection: 'C 位方向（主位位置）',
    directionTop: '上（前）',
    directionRight: '右',
    directionBottom: '下（后）',
    directionLeft: '左',
    leftToRight: '从左到右',
    rightToLeft: '从右到左',
    oddEvenMode: '旁边排序（主位两侧）',
    leftEvenRightOdd: '左边双数·右边单数',
    leftOddRightEven: '左边单数·右边双数',
    numberPreview: '当前座号',
    deleteUnit: '删除此单元',
    footerUnits: '{count} 个座位单元',
    footerSeats: '{count} 个座位',
    minAnchorPairs: '场地至少需要保留两组左右支点',
    deleteUnitConfirm: '确定删除“{name}”吗？删除后不可恢复。',
    controlSettings: {
      title: '控台设置',
      hint: '拖动控台可调整位置，不占用座位或参与人员分配。',
      width: '宽度（cm）',
      depth: '深度（cm）',
      delete: '删除控台'
    },
    removeAssignedSeatsTitle: '提示',
    removeAssignedSeatsConfirm: '调整布置将移除 {count} 位人员的座位（{names}）。这些人员将回到待分配名单，其他座位安排会保留。是否继续？',
    reduceSeatsInAssignedAreaConfirm: '已分配座位：{names}（{count} 位），位于 {units}。减少座位数量可能会调整座位编号，但不会移除这些人员的座位；其他座位安排会保留。是否继续？',
    undoStep: '撤回上一步',
    undoStepHint: '撤销最近一次布置调整',
    resetToInitial: '恢复初始',
    resetToInitialHint: '恢复到本次打开页面或最近保存时的状态',
    saveSuccess: '座位布置已保存',
    versionConflict: '当前座位场地已被其他操作更新，请刷新页面后重试。'
  },
  arrangementDialog: {
    title: '座位安排 · 选择参会名单',
    intro: '选择活动和会议场次后，可绑定报名已通过名单，或改用导入名单。',
    activity: '绑定活动',
    activityPlaceholder: '请选择活动',
    meeting: '会议场次',
    meetingPlaceholder: '请选择会议场次',
    wholeActivity: '整场活动（不区分会议场次）',
    rosterSourceLabel: '人员名单来源',
    rosterSourceHint: '请选择人员名单来源：读取本场会议已通过的报名名单，或下载模板后导入名单。',
    rosterSourceRegistration: '按本场会议报名名单',
    rosterSourceImported: '按导入名单',
    rosterCountWhole: '整场活动已通过报名人员 {count} 位',
    rosterCountMeeting: '该场次已通过报名人员 {count} 位',
    rosterEmptyWhole: '该活动暂无报名已通过的人员',
    rosterEmptyMeeting: '该场次暂无报名已通过的人员',
    rosterEmptyImported: '尚未导入名单，请下载模板填写后上传。',
    rosterCountImported: '已导入人员 {count} 位',
    importedTag: '导入人员',
    clearImported: '清空导入名单',
    importRequired: '请先上传至少一条导入名单人员。',
    rosterNoRegistration: '该活动未绑定报名表，暂无可读取的报名人员。',
    rosterLoadFailed: '报名人员读取失败，请稍后重试。',
    rosterLimit: '仅展示前 {shown} 位，共 {total} 位',
    columns: {
      index: '序号',
      name: '姓名',
      organization: '单位',
      jobTitle: '职务',
      status: '状态'
    },
    approved: '已通过',
    unnamed: '未命名参会人',
    noActivities: '暂无可绑定的活动',
    noSeatUnits: '当前场地还未添加座位单元，请先编辑布置并添加座位。',
    next: '下一步：安排座位',
    createSuccess: '座位安排已创建，正在进入座位编排…',
    createFailed: '座位安排创建失败，请稍后重试。',
    openFailed: '座位安排已创建，但未能打开座位编排页，请前往活动座位配置查看。'
  },
  skipDialog: {
    title: '跳过号码',
    introPrefix: '设置座位单元上 ',
    introEmphasis: '要避开的号码',
    introSuffix: '（如 4、7 等）。设置后，所有单元的座号生成都会自动跳过这些数字 —— 例如：原本依次为 1·2·3·4·5 的座位，跳过 4 和 7 后会变为 1·2·3·5·6。',
    commonUses: '常见用途：中式活动避讳 4 和 7；西方活动避开 13。',
    current: '当前跳过',
    removeOne: '点击移除该号码',
    empty: '尚未设置跳过的号码。添加后，所有单元的座号生成都会自动避开这些数字。',
    presets: '快捷预设',
    chinesePreset: '中式常用避讳（4、7）',
    chinesePresetTitle: '港台 / 东亚常见的避讳号',
    westernPreset: '西方常见避讳（13）',
    westernPresetTitle: '部分西方楼层、活动会避开 13',
    custom: '自定义添加',
    placeholder: '如 4 或 4,7,9-12（逗号分隔，支持起止区间）',
    add: '添加',
    helpPrefix: '支持单个号码（如 ',
    helpSingle: '4',
    helpListPrefix: '）、多个号码（如 ',
    helpList: '4,7,9',
    helpRangePrefix: '）或区间（如 ',
    helpRange: '9-12',
    helpSuffix: ' 表示 9、10、11、12）。',
    clear: '清空全部',
    apply: '应用到画布',
    applied: '跳过号码已应用，座位号已重新生成'
  },
  card: {
    enable: '启用席位卡片',
    enableHint: '组件内所有座位共用此卡片样式',
    size: '成品尺寸',
    sizeHints: {
      '90x55': '主流对折小成品，便携简洁',
      '105x74': '主流对折大成品，信息更充裕'
    },
    background: '背景图片',
    clickUpload: '点击上传图片',
    uploading: '上传中…',
    uploadHint: '支持 JPG / PNG，建议按成品尺寸比例上传',
    removeImage: '移除背景图片',
    replaceImage: '重新上传',
    fitMode: '图片适配',
    cover: '填充',
    contain: '适应',
    printFields: '打印信息（勾选后显示）',
    fieldName: '姓名',
    fieldOrganization: '单位',
    fieldJobTitle: '职位',
    nameSize: '姓名字号（pt）',
    textSize: '其他信息字号（pt）',
    textColor: '文字颜色',
    preview: '效果预览',
    sampleName: '示例姓名',
    sampleJobTitle: '示例职务',
    sampleOrganization: '示例单位',
    note: '席位卡片将按每个座位打印一份，打印时仅带入已勾选的姓名、单位和职位。图片将按所选适配方式铺满卡片正面；不开启图片时显示默认白底。',
    notePrint: '席位卡片用于打印或现场摆放在座位上。',
    noteImage: '图片按所选适配方式铺满卡片正面；未上传图片时显示默认白底。',
    noteSample: '预览中的姓名、职务和单位仅为示例，实际打印以座位分配人员为准。',
    uploadFailed: '图片上传失败，请重试',
    removeFailed: '背景图片删除失败，请重试'
  },
  png: {
    title: '下载 PNG',
    scale: '高清倍率',
    transparent: '透明背景',
    transparentHint: '开启后不导出白色 A4 底板',
    filename: '文件名',
    export: '下载',
    success: 'PNG 已生成',
    failed: 'PNG 导出失败，请重试'
  },
  types: {
    sofa: '沙发席位',
    round: '圆桌席位',
    cinema: '影院席位',
    meeting: '会议席位',
    control: '控台'
  },
  typeHints: {
    sofa: '一排横向沙发席，适合主席台',
    round: '圆桌环绕，适合宴会',
    cinema: '影院网格，适合论坛/培训',
    meeting: '中空方桌，固定会议桌长宽、按椅子尺寸自动排布，适合讨论 / 宴会'
  }
}
